export enum AffinityFirmProvisionStatusType {
    Pending = 0,
    SyncInitiated = 1,
    SyncComplete = 2,
    MappingInitiated = 3,
    MappingComplete = 4,
    Complete = 5,
    DoNotProvision = 6,
    Failed = 7
}

export function GetAffinityFirmProvisionStatusType(affinityProvisioningStatus: string): AffinityFirmProvisionStatusType {

    if (!affinityProvisioningStatus || affinityProvisioningStatus.length === 0) {
        return AffinityFirmProvisionStatusType.DoNotProvision;
    }

    switch (affinityProvisioningStatus.toLocaleLowerCase()) {
        case 'pending':
            return AffinityFirmProvisionStatusType.Pending;
        case 'complete':
            return AffinityFirmProvisionStatusType.Complete;
        case 'syncinitiated':
            return AffinityFirmProvisionStatusType.SyncInitiated;
        case 'synccomplete':
            return AffinityFirmProvisionStatusType.SyncComplete;
        case 'mappinginitiated':
            return AffinityFirmProvisionStatusType.MappingInitiated;
        case 'mappingcomplete':
            return AffinityFirmProvisionStatusType.MappingComplete;
        case 'failed':
            return AffinityFirmProvisionStatusType.Failed;
        default:
            return AffinityFirmProvisionStatusType.DoNotProvision;
    }
}